import { isStandaloneMode } from "./pwa-utils"
import { isElectronApp } from "./electron"

type Runtime = "browser" | "pwa" | "electron"

export function getRuntime(): Runtime {
	if (isElectronApp) {
		return "electron"
	}

	if (isStandaloneMode()) {
		return "pwa"
	}

	return "browser"
}
